module.exports = __webpack_public_path__ + "static/media/DahboardSelect.7db801c8.svg";